module.exports = __webpack_public_path__ + "static/media/bluelock.bf24a1b5.svg";